export const EnumLabels = {
    STATUS: {
        NEW: "Yeni",
        REVIEWING: "İncelemede",
        APPROVED: "Onaylandı",
        REJECTED: "Reddedildi",
        WITHDRAWN: "Vazgeçti",
    },

    GENDER: {
        MALE: "Erkek",
        FEMALE: "Kadın",
    },

    INTEREST_AREA: {
        COACHING: "Antrenörlük",
        MANAGEMENT: "Yönetim",
        REFEREE: "Hakemlik",
        PLAYER_ANALYSIS: "Oyuncu Analizi",
        SPORTS_JOURNALISM: "Spor Yazarlığı",
        OTHER: "Diğer",
    },

    ENROLLMENT_STATUS: {
        ACTIVE: "Aktif",
        COMPLETED: "Tamamlandı",
        DROPPED: "Bıraktı",
        SUSPENDED: "Dondurdu",
    },

    TERM_TYPE: {
        ONLINE: "Online",
        PHYSICAL: "Fiziksel",
    },

    APPLICATION_CHANNEL: {
        ONLINE: "Online",
        PHYSICAL: "Fiziksel",
    },

    IDENTITY_DOCUMENT_TYPE: {
        TCKN: "T.C. Kimlik No",
        PASSPORT: "Pasaport",
    },

};

export function tEnum(group, value) {
    return EnumLabels[group]?.[value] || value || "-";
}
